




















































import Vue from "vue";
import Modal from "@/components/Modal/Modal.vue";
import { Survey } from "@/store/modules/Survey/interface";
import { Poste } from "@/store/modules/Poste/interface";
import { store } from "@/store/store";
import { Response_ } from "@/plugins/axios/response";
import { PosteActionsTypes } from "@/store/modules/Poste/types";
import { ApiResponse } from "@/types/types";
import Utils from "@/utils/utils";

export default Vue.extend({
  name: "DeviceAssignationModal",
  components: { Modal },
  props: {
    should_display: {
      type: Boolean,
      default: false
    },
    onClose: {
      type: Function,
      default: () => undefined
    },
    device: {
      type: Object
    },
    onAction: {
      type: Function,
      default: () => undefined
    }
  },
  data(): any {
    return {
      survey_id: null,
      poste_id: null,
      loading: false
    };
  },
  methods: {
    onSurveyChange(value: string): void {
      this.poste_id = null;
      this.survey_id = value;
    },
    onPosteChange(value: string): void {
      this.poste_id = value;
    },
    async should_validate() {
      this.loading = true;
      if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
        const request_result = await this.onUpdate({ material: this.device._id, _id: this.poste_id });
        if (
          (request_result as Response_).status === ApiResponse.CREATED ||
          (request_result as Response_).status === ApiResponse.SUCCESS
        ) {
          this.onAction({
            type: "SUCCESS",
            title: "Poste",
            content: (request_result as Response_).message
          });
          this.loading = false;
          this.onClose();
          return;
        } else {
          this.onAction({
            type: "ERROR",
            title: "Erreur",
            content: (request_result as Response_).message
          });
        }
      }
      this.loading = false;
    },
    async onUpdate(poste: Poste): Promise<Response_> {
      return store.dispatch(PosteActionsTypes.UPDATE_POSTE, poste);
    },
    isActive(survey: Survey): boolean {
      const diff_start = Utils.getDifferenceBetweenDate(Date.now(), new Date(survey.start_date).getTime());
      const diff_end = Utils.getDifferenceBetweenDate(Date.now(), new Date(survey.end_date).getTime());
      if (diff_end > 0) {
        return false;
      } else if (diff_start >= 0 && diff_end <= 0) {
        return true;
      } else {
        return true;
      }
    }
  },
  computed: {
    surveys(): Array<Survey> {
      return store.getters.SURVEY_ALL_ID.map((survey) => store.getters.SURVEY_BY_ID[survey]).filter((survey) =>
        this.isActive(survey)
      );
    },
    postes(): Array<Poste> {
      return store.getters.POSTE_ALL_ID.map((poste) => store.getters.POSTE_BY_ID[poste]).filter(
        (poste) => poste.survey === this.survey_id && (poste.material === null || poste.material === undefined)
      );
    },
    surveyRules(): Array<(value: string) => boolean | string> {
      return [
        (value: string): boolean | string => (value !== null && value.length > 0) || `Le champ Enquête est obligatoire.`
      ];
    },
    posteRules(): Array<(value: string) => boolean | string> {
      return [
        (value: string): boolean | string => (value !== null && value.length > 0) || `Le champ Poste est obligatoire.`
      ];
    }
  }
});
